(function () {
  var RX_PARSER_URL = "https://joiuss-rx-parser.paul-cb8.workers.dev/parse";

  function toJpeg(file, callback ) {
    // If already JPEG or PNG, send as-is
    if (file.type === "image/jpeg" || file.type === "image/png") {
      return callback(null, file);
    }
    // Convert AVIF, WEBP, HEIC etc. to JPEG via canvas
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext("2d").drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      canvas.toBlob(function (blob) {
        if (!blob) return callback(new Error("Could not convert image"));
        callback(null, new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), { type: "image/jpeg" }));
      }, "image/jpeg", 0.95);
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      callback(new Error("Could not load image for conversion"));
    };
    img.src = url;
  }

  window.__MONOCLE_RX_WORKER__ = function (file, callback) {
    if (!file) return callback(new Error("No file provided"));
    toJpeg(file, function (err, jpegFile) {
      if (err) return callback(err);
      var form = new FormData();
      form.append("prescription", jpegFile);
      fetch(RX_PARSER_URL, { method: "POST", body: form })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.success || !data.values) {
            return callback(new Error(data.error || "No values returned"));
          }
          callback(null, data.values, data.confidence, data.warnings);
        })
        .catch(function (err) { callback(err); });
    });
  };

  console.log("[MONOCLE] RX Worker registered");
})();
